import {Pipe} from "@angular/core";
import { ReportModel } from "./ReportModel";

/**
 * A simple string filter, since Angular does not yet have a filter pipe built in.
 */
@Pipe({
    name: 'stringFilter'
})
export class StringFilterPipe {

    transform(value: ReportModel[], q: string) {
        //console.log("value from pipe: ", value)
        //console.log("string from pip: ", q)
        if (!q || q === '') {
            return value;
        }
        return value.filter(item => -1 < item.reportTitle.toLowerCase().indexOf(q.toLowerCase()));
    }
}


// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/shared/classes/StringFilterPipe.ts